module.exports = __webpack_public_path__ + "img/thumbnail_Wolverine_f_normal.09f28792.png";